import React from "react";

import momentjs from "moment";
import { useIntl } from "react-intl";
import styled from "styled-components";

import useMediaQuery from "Hooks/useMediaQuery";
import { formatAsCurrency } from "Libs/utils";

const formatDate = date => momentjs(date).format("D MMM, YYYY");
const month = date => momentjs(date).format("MMM");
const longPeriod = (start, end) => formatDate(start) + " - " + formatDate(end);

export const OrderHeader = ({ order }) => {
  const intl = useIntl();
  const date = useMediaQuery("(min-width: 32rem)")
    ? longPeriod(order.billing_period_start, order.billing_period_end)
    : month(order.billing_period_start);

  return (
    <OrderHeaderSS>
      <OrderIdSS>{order.id}</OrderIdSS>

      <OrderPeriodSS>{date}</OrderPeriodSS>

      <OrderStatusSS>
        {intl.formatMessage({ id: `order_status.${order.status}` })}
      </OrderStatusSS>

      <OrderTotalSS>
        <OrderTotalLabelSS>
          {intl.formatMessage({ id: "total" })}
        </OrderTotalLabelSS>
        {formatAsCurrency(order.total, order.currency)}
      </OrderTotalSS>
    </OrderHeaderSS>
  );
};

const OrderHeaderSS = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 18px 32px;

  font-size: 13px;
  font-style: normal;
  text-decoration: none;
  line-height: 24px; /* 160% */

  border-radius: 8px 8px 0 0;
  cursor: pointer;
  color: var(--link-ebony-color, var(--ebony));
  background-color: var(--section-ice-background-color, var(--ice));
`;

const OrderIdSS = styled.div`
  color: var(--section-ebony-color, var(--ebony));
  font-size: 15px;
  font-weight: 600;
  text-decoration: none;
  flex-grow: 1;
`;

const OrderPeriodSS = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: var(--section-ebony-light-color, var(--ebony-light));
  text-align: left;
  flex-grow: 1;

  @media (min-width: 32rem) {
    min-width: 12rem;
    max-width: 32rem;
    margin-left: auto;
    flex-grow: 2;
  }
  @media (min-width: 48rem) {
    flex-grow: 1;
  }
`;

const OrderStatusSS = styled.span`
  display: none;
  font-size: 13px;
  font-weight: 600;
  color: var(--section-ebony-light-color, var(--ebony-light));
  text-align: left;
  flex-grow: 1;

  @media (min-width: 48rem) {
    display: inline-block;
    max-width: 10rem;
  }
`;

const OrderTotalSS = styled.span`
  color: var(--section-ebony-color, var(--ebony));
  display: flex;
  margin-right: 8px;
  font-size: 15px;
  font-weight: 700;

  @media (min-width: 48rem) {
    margin-right: 74px;
  }
`;

const OrderTotalLabelSS = styled.span`
  display: none;
  color: var(--section-granite-color, var(--granite));
  font-size: 13px;
  font-weight: 600;
  margin-right: 32px;

  @media (min-width: 32rem) {
    display: inline-block;
  }
`;
